export enum MainSteps {
  COMPLETE_ACCOUNT_SETUP = 'COMPLETE_ACCOUNT_SETUP',
  CONSULT_FIRST_PATIENT = 'CONSULT_FIRST_PATIENT',
  PERFORM_FIRST_TELECONSULTATION = 'PERFORM_FIRST_TELECONSULTATION',
  REQUEST_DOCTOR_EXPERTISE = 'REQUEST_DOCTOR_EXPERTISE',
  ACTIVATE_ONLINE_APPOINTMENTS = 'ACTIVATE_ONLINE_APPOINTMENTS',
  CREATE_WAITING_ROOM = 'CREATE_WAITING_ROOM',
  CONFIGURE_VIDEO_CONFERENCE_EQUIPMENT = 'CONFIGURE_VIDEO_CONFERENCE_EQUIPMENT',
}

// child steps enum

export enum AccountSetupSteps {
  VALIDATE_EMAIL = 'VALIDATE_EMAIL',
  VALIDATE_PHONE = 'VALIDATE_PHONE',
  SETUP_STRIPE = 'SETUP_STRIPE',
  SETUP_TWO_FACTOR_AUTH = 'SETUP_TWO_FACTOR_AUTH',
  VALIDATE_RPPS_NUMBER = 'VALIDATE_RPPS_NUMBER',
}

export enum ConsultFirstPatientSteps {
  CREATE_FIRST_PATIENT = 'CREATE_FIRST_PATIENT',
  PERFORM_LOCAL_CONSULTATION = 'PERFORM_LOCAL_CONSULTATION',
}

export enum FirstTeleconsultationSteps {
  INVITE_DOCTOR = 'INVITE_DOCTOR',
  SCHEDULE_TELECONSULTATION = 'SCHEDULE_TELECONSULTATION',
  PERFORM_TELECONSULTATION = 'PERFORM_TELECONSULTATION',
}
export enum OnlineAppointmentsSteps {
  CREATE_APPOINTMENT_LINK = 'CREATE_APPOINTMENT_LINK',
  ADD_APPOINTMENT_SLOTS = 'ADD_APPOINTMENT_SLOTS',
  ADD_DOCTOR_TO_LIST = 'ADD_DOCTOR_TO_LIST',
  ACCEPT_APPOINTMENT_REQUEST = 'ACCEPT_APPOINTMENT_REQUEST',
  PERFORM_APPOINTMENT_BASED_CONSULTATION = 'PERFORM_APPOINTMENT_BASED_CONSULTATION',
}
export enum DoctorExpertiseSteps {
  PERFORM_EXAM = 'PERFORM_EXAM',
  REQUEST_EXPERTISE = 'REQUEST_EXPERTISE',
  SEND_EXPERTISE_OMNIDOC = 'SEND_EXPERTISE_OMNIDOC',
}
export enum WaitingRoomSteps {
  CREATE_WAITING_ROOM = 'CREATE_WAITING_ROOM',
  SETUP_OPENING_HOURS = 'SETUP_OPENING_HOURS',
  PERFORM_WAITING_ROOM_CONSULTATION = 'PERFORM_WAITING_ROOM_CONSULTATION',
}
export enum VideoConfEquipmentSteps {
  SETUP_CAMERA = 'SETUP_CAMERA',
  SETUP_MIC = 'SETUP_MIC',
}
